module.exports = __webpack_public_path__ + "img/agent-6.png";